(() => {
  const controllers = new WeakMap();
  let pending = false;
  let uncertain = false;
  const root = () => window.Shopify?.routes?.root || '/';
  const emit = (name, detail) => document.documentElement.dispatchEvent(new CustomEvent(name, {bubbles:true,detail}));
  const queryAll = (selector, parent=document) => [...parent.querySelectorAll(selector)];
  function cartDrawer() {return document.getElementById('cart-drawer');}
  async function openCart(refresh=false) {
    const drawer = cartDrawer();
    if (!drawer) throw new Error('Cart drawer missing');
    await customElements.whenDefined(drawer.localName);
    if (refresh) emit('cart:refresh', {});
    if (typeof drawer.show === 'function') drawer.show();
    else drawer.setAttribute('open','');
  }
  function config() {return document.querySelector('[data-bl-configurator]');}
  function controller() {return controllers.get(config());}
  function setBusy(value) {
    pending=value;
    queryAll('[data-bl-add], [data-bl-accessory]').forEach(b=>{b.setAttribute('aria-busy',String(value));if(value)b.disabled=true;});
    queryAll('[data-bl-configurator] input').forEach(input=>input.disabled=value);
    controller()?.render(false);
  }
  async function addItems(items, errorNode, button) {
    const app=controller();
    if(pending||uncertain||!app)return;
    errorNode.hidden=true;errorNode.textContent='';
    const drawer=cartDrawer();
    if(!drawer){errorNode.textContent=app.data.labels.error;errorNode.hidden=false;return;}
    setBusy(true);
    let accepted=false;
    let postStarted=false;
    try{
      await customElements.whenDefined(drawer.localName);
      const sections=[];emit('cart:prepare-bundled-sections',{sections});
      const ownId=drawer.dataset.sectionId || drawer.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-','');
      if(ownId&&!sections.includes(ownId))sections.unshift(ownId);
      const ids=[...new Set(sections)].slice(0,5);
      postStarted=true;
      const response=await fetch(root()+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items,sections:ids,sections_url:location.pathname})});
      const result=await response.json();
      if(!response.ok){postStarted=false;throw new Error(typeof result.description==='string'?result.description:app.data.labels.error);}
      accepted=true;
      const cartResponse=await fetch(root()+'cart.js',{credentials:'same-origin',headers:{'Accept':'application/json'}});
      if(!cartResponse.ok)throw new Error(app.data.labels.uncertain);
      const cart=await cartResponse.json();
      cart.sections=result.sections||{};
      if(ids.some(id=>!cart.sections[id])){
        const url=new URL(root(),location.origin);url.searchParams.set('sections',ids.join(','));
        const refreshed=await fetch(url,{credentials:'same-origin'});
        if(!refreshed.ok)throw new Error(app.data.labels.uncertain);
        Object.assign(cart.sections,await refreshed.json());
      }
      if(ownId&&!cart.sections[ownId])throw new Error(app.data.labels.uncertain);
      emit('cart:change',{baseEvent:'variant:add',cart});
      emit('variant:add',{items:result.items||[result],cart});
      await openCart();
      app.node.querySelector('[data-bl-status]').textContent=app.data.labels.added;
      document.querySelectorAll('cart-count').forEach(el=>el.textContent=cart.item_count);
    }catch(error){
      if(accepted||postStarted){uncertain=true;errorNode.textContent=app.data.labels.uncertain;app.node.querySelector('[data-bl-open-cart]').hidden=false;try{await openCart(true);}catch{}}
      else{errorNode.textContent=error.message||app.data.labels.error;emit('cart:refresh',{});}
      errorNode.hidden=false;
    }finally{setBusy(false);button?.removeAttribute('aria-busy');}
  }
  class BabyLuxe {
    constructor(node){
      this.node=node;this.data=JSON.parse(node.querySelector('[data-bl-data]').textContent);this.color=0;this.thickness=0;this.package='bundle';this.galleryIndex=0;
      this.abort=new AbortController();const options={signal:this.abort.signal};
      node.addEventListener('change',event=>{
        if(event.target.name?.startsWith('bl-color-')){this.color=Number(event.target.value);this.galleryIndex=0;this.render(true);}
        if(event.target.name?.startsWith('bl-thickness-')){this.thickness=Number(event.target.value);this.render(false);}
        if(event.target.name?.startsWith('bl-package-')){this.package=event.target.value;this.render(false);}
      },options);
      node.addEventListener('click',event=>{
        const thumb=event.target.closest('[data-bl-thumb]');
        if(thumb){this.galleryIndex=Number(thumb.dataset.blThumb);this.showImage();}
        if(event.target.closest('[data-bl-add]'))this.add();
        if(event.target.closest('[data-bl-open-cart]')){openCart(true).then(()=>{uncertain=false;this.render(false);}).catch(()=>{});}
      },options);
      this.observer=new IntersectionObserver(entries=>{node.querySelector('[data-bl-sticky]').hidden=entries[0].isIntersecting;},{threshold:0});
      this.observer.observe(node.querySelector('.bl-add'));
      this.render(true);
    }
    product(){return this.data.colors[this.color]?.products[this.thickness];}
    parts(){return this.package==='bundle'?[this.product(),this.data.welcool,this.data.wind]:[this.product()];}
    money(cents){return new Intl.NumberFormat(this.data.locale||'nl-NL',{style:'currency',currency:this.data.currency||'EUR'}).format((cents||0)/100);}
    text(selector,value){queryAll(selector).forEach(el=>el.textContent=value);}
    showImage(){
      const product=this.product();const img=product.images[this.galleryIndex]||product.images[0];
      if(img){const main=this.node.querySelector('[data-bl-image]');main.src=img.src;main.alt=img.alt||product.title;}
      queryAll('[data-bl-thumb]',this.node).forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.blThumb)===this.galleryIndex)));
    }
    render(rebuildGallery){
      const p=this.product();if(!p)return;
      const sum=parts=>parts.reduce((v,x)=>v+(x?.price||0),0);
      const compare=parts=>parts.reduce((v,x)=>v+Math.max(x?.price||0,x?.compare||0),0);
      const bundle=[p,this.data.welcool,this.data.wind], selected=this.parts();
      this.text('[data-bl-color-name]',this.data.colors[this.color].name);
      this.text('[data-bl-base-price],[data-bl-single-price]',this.money(p.price));
      this.text('[data-bl-base-compare],[data-bl-single-compare]',p.compare>p.price?this.money(p.compare):'');
      this.text('[data-bl-bundle-price]',this.money(sum(bundle)));
      this.text('[data-bl-bundle-compare]',compare(bundle)>sum(bundle)?this.money(compare(bundle)):'');
      this.text('[data-bl-selected-price]',this.money(sum(selected)));
      this.text('[data-bl-selected-compare]',compare(selected)>sum(selected)?this.money(compare(selected)):'');
      this.text('[data-bl-summary]',p.title+' · '+(this.package==='bundle'?this.data.labels.bundle:'Baby Luxe'));
      this.text('[data-bl-included-thickness]',this.thickness===0?'2,5 cm':'3,5 cm');
      const saving=this.node.querySelector('[data-bl-saving]');saving.hidden=p.compare<=p.price;saving.textContent=this.data.labels.save+' '+this.money(p.compare-p.price);
      const available=selected.every(x=>x?.available&&x?.id);
      queryAll('[data-bl-add]').forEach(b=>b.disabled=pending||uncertain||!available);
      this.text('[data-bl-button-label]',pending?this.data.labels.adding:available?this.data.labels.add:this.data.labels.sold);
      queryAll('[data-bl-accessory]').forEach(b=>{if(!b.dataset.initiallyDisabled)b.dataset.initiallyDisabled=String(b.disabled&&!pending&&b.getAttribute('aria-busy')!=='true');b.disabled=pending||uncertain||b.dataset.initiallyDisabled==='true';});
      if(!available)this.node.querySelector('[data-bl-status]').textContent=this.data.labels.sold;
      else if(!pending)this.node.querySelector('[data-bl-status]').textContent='';
      for(const name of ['bundle','sticky']){const el=this.node.querySelector('[data-bl-'+name+'-image]');if(el&&p.images[0]){el.src=p.images[0].thumb;el.alt=p.title;}}
      if(rebuildGallery){
        const container=this.node.querySelector('[data-bl-thumbs]');container.replaceChildren();
        const choices=[0,2,8,6,7,14].filter(i=>p.images[i]);
        for(const index of choices){const img=p.images[index],button=document.createElement('button'),image=document.createElement('img');button.type='button';button.dataset.blThumb=String(index);button.setAttribute('aria-label',img.alt||p.title+' '+(index+1));button.setAttribute('aria-pressed',String(index===0));image.src=img.thumb;image.alt='';image.width=100;image.height=100;image.loading='lazy';button.append(image);container.append(button);}
        this.showImage();
      }
    }
    add(){if(this.parts().some(p=>!p?.available||!p.id))return;return addItems(this.parts().map(p=>({id:p.id,quantity:1})),this.node.querySelector('[data-bl-error]'));}
    destroy(){this.abort.abort();this.observer.disconnect();}
  }
  function init(){queryAll('[data-bl-configurator]').forEach(node=>{if(!controllers.has(node))controllers.set(node,new BabyLuxe(node));});queryAll('[data-bl-accessory]').forEach(b=>{if(!b.dataset.initiallyDisabled)b.dataset.initiallyDisabled=String(b.disabled);});}
  document.addEventListener('click',event=>{
    const add=event.target.closest('[data-bl-accessory]');if(add){addItems([{id:Number(add.dataset.blAccessory),quantity:1}],add.closest('article').querySelector('[data-bl-accessory-error]'),add);}
    const toggle=event.target.closest('.bl-cart-toggle');if(toggle){event.preventDefault();openCart().catch(()=>{});}
  });
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',event=>{const node=event.target.querySelector('[data-bl-configurator]');controllers.get(node)?.destroy();if(node)controllers.delete(node);});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();

if(!customElements.get('deryan-logo-carousel')){
  customElements.define('deryan-logo-carousel',class extends HTMLElement{
    connectedCallback(){
      this.track=this.querySelector('.bl-logo-track');
      this.prev=this.querySelector('[data-bl-logo-prev]');
      this.next=this.querySelector('[data-bl-logo-next]');
      if(!this.track||!this.prev||!this.next)return;
      this.abort=new AbortController();
      const options={signal:this.abort.signal};
      this.prev.hidden=false;this.next.hidden=false;
      this.prev.addEventListener('click',()=>this.move(-1),options);
      this.next.addEventListener('click',()=>this.move(1),options);
      this.track.addEventListener('scroll',()=>this.update(),{...options,passive:true});
      this.track.addEventListener('keydown',event=>{
        if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.move(event.key==='ArrowRight'?1:-1);}
        if(event.key==='Home'||event.key==='End'){event.preventDefault();this.track.scrollTo({left:event.key==='Home'?0:this.track.scrollWidth,behavior:this.motion()});}
      },options);
      this.resize=new ResizeObserver(()=>this.update());this.resize.observe(this.track);this.update();
    }
    motion(){return matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth';}
    move(direction){const card=this.track.firstElementChild;const gap=parseFloat(getComputedStyle(this.track).columnGap)||0;this.track.scrollBy({left:direction*((card?.getBoundingClientRect().width||120)+gap),behavior:this.motion()});}
    update(){const max=this.track.scrollWidth-this.track.clientWidth;this.prev.disabled=this.track.scrollLeft<=2;this.next.disabled=this.track.scrollLeft>=max-2;}
    disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();}
  });
}
